module.exports = __webpack_public_path__ + "img/img64.c1a9f38a.svg";